import { ClientDTO, DncDetailsDTO, IDncByTeam, ILocation } from 'wisestep-api';
import { FieldOption } from 'wisestep-base';

import { INameAndId } from '../../../features/jobs/assign/types';

export interface IFilters {
  search: string;
  status: string[] | null;
  clientNameAndIds: INameAndId[];
  tags?: string[];
  clients: ClientDTO[];
  isMyContact?: boolean;
  contactOwners?: string[];
  createdByIds?: string[];
  fromDate?: string;
  toDate?: string;
  location?: ILocation | null;
  supervisors?: string[];
  filterByDateType?: string;
}

export const contactsDefaultFilterValues = {
  search: '',
  status: [],
  clientNameAndIds: [],
  tags: [],
  clients: [],
  contactOwners: [],
  createdByIds: [],
  fromDate: '',
  toDate: '',
  location: null,
  supervisors: [],
  filterByDateType: '',
};

export const defaultColumnSettings = (): FieldOption[] => [
  { id: 'firstName', checked: true, required: true },
  { id: 'clientName', checked: true },
  { id: 'markStatus', checked: true },
  { id: 'tags', checked: true },
  { id: 'activeLeadCount', checked: true },
  { id: 'position', checked: false },
  { id: 'emailAddress', checked: false },
  { id: 'owner', checked: true },
  { id: 'location', checked: false },
  { id: 'phoneNumber', checked: false },
  { id: 'createdByName', checked: false },
  { id: 'createdOn', checked: true },
  { id: 'action', checked: true, required: true },
];

export function mapDncDetailsDtoToIdncByTeam(dto: DncDetailsDTO): IDncByTeam {
  return {
    dataPrivacyOption: dto.dataPrivacyOption,
    dncEndDate: new Date(dto.dncEndDate),
    notes: dto.notes,
    isInDnc: dto.isInDnc,
    isAddedByCandidate: dto.isAddedByCandidate,
    createdOn: dto.createdOn ? new Date(dto.createdOn) : new Date(),
    createdBy: dto.createdBy ?? '',
    candidateId: '',
    id: '',
    teamIds: [],
    recruiterId: '',
    dncLogId: '',
    modifiedOn: new Date(),
    modifiedBy: '',
    acceptedOn: new Date(),
    deleteRequestAcceptedBy: '',
    isDeleted: false,
  };
}
